/**
 * Date d'expiration de carte (masque « 99 / 99 ») : remplissage automatique et collage.
 *
 * Retour de Ségolène du 15/10 (Chrome sur iPhone) : la carte enregistrée expire en 05/28, le remplissage automatique
 * écrit l'année sur quatre chiffres (« 05/2028 ») et le masque garde les quatre premiers chiffres : « 05 / 20 ». Une
 * saisie de plusieurs caractères à la fois (remplissage, collage) est relue ici : mois sur un ou deux chiffres, année
 * sur deux ou quatre, séparée ou non. La frappe chiffre par chiffre ne passe pas par là (le masque la gère).
 */

/** « 05/2028 », « 5/28 », « 05 / 2028 », « 052028 », « 05-28 » → « 05 / 28 » ; null si ce n'est pas une date. */
export function normalizeCardExpiry(input: string): string | null {
  const text = input.trim();
  let month: string;
  let year: string;
  const parts = text.match(/^(\d{1,2})\s*[/.\-\s]\s*(\d{2}|\d{4})$/);
  if (parts) {
    [, month, year] = parts;
  } else if (/^\d{6}$/.test(text) && text.slice(2, 4) === '20') {
    month = text.slice(0, 2);
    year = text.slice(2);
  } else {
    return null;
  }
  const m = Number(month);
  if (m < 1 || m > 12) return null;
  return `${String(m).padStart(2, '0')} / ${year.slice(-2)}`;
}

interface MaskState {
  value: string;
  selection: { start: number; end: number } | null;
}

/**
 * `beforeMaskedValueChange` de react-input-mask 2 : quand plusieurs caractères arrivent d'un coup (remplissage
 * automatique, collage), la date reconnue remplace la valeur masquée ; sinon, rien ne change.
 */
export function cardExpiryBeforeMaskedValueChange(
  newState: MaskState,
  _oldState: MaskState,
  userInput: string | null,
): MaskState {
  if (!userInput || userInput.length < 3) return newState;
  const value = normalizeCardExpiry(userInput);
  if (!value) return newState;
  return { value, selection: { start: value.length, end: value.length } };
}

/**
 * Props à étaler sur l'`<Input as={ReactInputMask}>` du champ d'expiration. Le paquet installé est react-input-mask 2
 * (prop `beforeMaskedValueChange`), mais @types/react-input-mask décrit la v3 (`beforeMaskedStateChange`) : la prop
 * n'existe pas pour TypeScript, d'où cet objet sans type précis.
 */
export const cardExpiryMaskProps: object = { beforeMaskedValueChange: cardExpiryBeforeMaskedValueChange };
